import { parseJwtPayload } from './util';
import { StorageRepository } from '../common/storage-repository';
export class TokenSessionStorageRepository {
    constructor() {
        this.repository = new StorageRepository(window.sessionStorage, 'access_token');
    }
    getToken() {
        return this.repository.get();
    }
    getJwtPayload() {
        const jwtPayloadString = this.getToken();
        if (!jwtPayloadString) {
            return null;
        }
        return parseJwtPayload(jwtPayloadString);
    }
    setToken(accessToken) {
        this.repository.set(accessToken);
    }
    clearToken() {
        this.repository.clear();
    }
}
